import React from "react";

const Layout = ({children, color,header,title="TITULO",button}) => {
  return (
    <div className="w-full h-[100vh] flex justify-center items-center">
      <div className="w-[360px] relative">
        <div className={`w-full p-4 min-w-[300px] border border-t-[15px] rounded-xl`}
        style={{borderColor: color}}
        >
          {header &&  <div className="w-full underline text-right text-xs text-gray-500">
            <a href={header.url}>
              {header.text}
            </a>
          </div>
          }
          <h2 className="text-2xl font-bold mb-5"
          style={{color: color}}>
            {title}
          </h2>
           
            {children}
            <button
            onClick={button.onClick}
            className="mt-4 w-full text-center rounded-xl py-4 font-bold text-white text-sm"
            style={{ background: color }}
          >
            {button.text}
          </button>  
        </div>
      </div>
    </div>
  );
};

export default Layout;
